$(".bulletin").slick({
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    arrows: false
});

$(".goodiesSliderMob").slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: true,
            dots: false,
            mobileFirst: true,
            responsive: [
                {
                breakpoint: 989,
                lazyLoad: 'progressive',
                settings: "unslick",
                }, 
             
            ],
});

// sidebar sliding function
function showCartModal(product) {
   ajaxfetchCart(product);
    $("body").removeClass("showModal showAccountModal"),
        $("body").addClass("showModal showCartModal"),
        $(".trulySidebarModelOverlay").fadeIn(100),
        $(".cart_favorite_item_slider").resize()
}

function showAccountModal() {
    $("body").removeClass("showModal showCartModal"),
        $("body").addClass("showModal showAccountModal"),
        $(".trulySidebarModelOverlay").fadeIn(100)
}

function showSearchModal() {
    $("body").removeClass("showModal showAccountModal"),
        $("body").removeClass("showModal showCartModal"),
        $("body").addClass("showModal showSearchModal"),
        $(".trulySidebarModelOverlay").fadeIn(100)

    //$('.beforeSearch__Slider').slick(beforeSearch__Slider);
}

function hideModal() {
    $("body").removeClass("showModal showAccountModal showCartModal showSearchModal"),
      $("html").removeClass("noscroll"),
        $(".trulySidebarModelOverlay").fadeOut(100)
}

function showSignup() {
    $(".modeSignupForm").show(),
        $(".modeLoginForm").hide(),
        $(".modeForgetForm").hide()
}

function showLogin() {
    $(".modeLoginForm").show(),
        $(".modeSignupForm").hide(),
        $(".modeForgetForm").hide()
}

function showforgot() {
    $(".modeLoginForm").hide(),
        $(".modeSignupForm").hide(),
        $(".modeForgetForm").show()
}
// adding fixed header
// $(window).scroll((function () {
//     $(window).scrollTop() >= 40 ? $("header").addClass("header_fixed") : $("header").removeClass("header_fixed")
// }));

// mobile nav toggle
$(".main-menuBar-toggleBtn").click(function () {
    $("body").toggleClass("open_nav");
    $(".main-menuBar-menuholder").slideToggle(300);
});

// function hideMenu() {
//     $("body").removeClass("open_nav"), $(".main-menuBar-menuholder").slideUp(300)
// }

$(".main-title-mega-menu").click((function () {
    $(this).parent().siblings().removeClass("active"),
        $(this).parent().siblings().find(".quick-links").slideUp(),
        $(this).next(".quick-links").slideToggle(),
        $(this).parent().toggleClass("active")
}))



/*Heart on cart button*/
jQuery.rnd = function (m, n) {
    m = parseInt(m);
    n = parseInt(n);
    return Math.floor(Math.random() * (n - m + 1)) + m;
}

$('.showHeart').mouseenter(function () {
    var heartcount = ($(this).width() / 90) * 5;
    for (var i = 0; i <= heartcount; i++) {
        var size = ($.rnd(60, 120) / 10);
        $(this).append('<span class="particle" style="top:' + $.rnd(20, 140) + '%; left:' + $.rnd(0, 100) + '%;width:' + size + 'px; height:' + size + 'px;animation-delay: ' + ($.rnd(0, 30) / 5) + 's;"></span>');
    }
});

$('.showHeart').mouseleave(function () {
    $(this).find('span.particle').remove();
});

function togglePassword() {
     var x = document.getElementById("RegisterForm-password");
       var y = document.getElementById("customer_password");
     var z = document.getElementById("ResetPassword");
    var z = document.getElementById("password");
     
    if (document.getElementById('RegisterForm-password') != null) {
     if (x.type === "password") {
       x.type = "text";
       $(".passworEye img").css({"opacity": "1"}); 
     } else {
       x.type = "password";
       $(".passworEye img").css({"opacity": "0.5"}); 
     }
   }
      if (document.getElementById('customer_password') != null) {

       if (y.type === "password") {
       y.type = "text";
       $(".passworEye img").css({"opacity": "1"}); 
     } else {
       y.type = "password";
       $(".passworEye img").css({"opacity": "0.5"}); 
     }
      }
   
     if (document.getElementById('ResetPassword') != null) {

     if (z.type === "password") {
       z.type = "text";
       $(".passworEye img").css({"opacity": "1"}); 
     } else {
       z.type = "password";
       $(".passworEye img").css({"opacity": "0.5"}); 
     }
     }
    if (document.getElementById('password') != null) {

     if (z.type === "password") {
       z.type = "text";
       $(".infpassworEye img").css({"opacity": "1"}); 
     } else {
       z.type = "password";
       $(".infpassworEye img").css({"opacity": "0.5"}); 
     }
     }
   }

// Window less then 767px 
// $(document).ready(function () {
//     if ($(window).width() <= 989) {
//         $('.verticalMenu').hide();

//         $(".toggle_sidebar").click(function () {

//             $(".toggle_sidebar").removeClass("toggle_open")
//             $(".verticalMenu").slideUp("normal");

//             if ($(this).next(".verticalMenu").is(':hidden') == true) {
//                 $(this).addClass("toggle_open");
//                 $(this).next(".verticalMenu").slideDown("normal")
//             }
//         });
//     }
// });


 $(function() {
 if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
 $('body').addClass('safari-mac');
 }
 });

/**before-after*****/
if ($(".beforeAfter__Result").length > 0) {  
function moveDivisor() {
            if (slider.value > 2 && slider.value < 98) {
                handle.style.left = slider.value + "%";
                divisor.style.width = slider.value + "%";
            }
 }

window.onload = function () {
            moveDivisor();
};  
(function ($) {
 $(document).ready(function () {
                // Before After Compare Slider
                var divisor = document.getElementById("divisor"),
                    handle = document.getElementById("handle"),
                    slider = document.getElementById("slider");
});
})(jQuery);        
}

// Only One video At a time
document.addEventListener('play', function (e) {
    var videos = document.getElementsByTagName('video');
    for (var i = 0, len = videos.length; i < len; i++) {
        if (videos[i] != e.target) {
            videos[i].pause();
            $(videos[i]).parents('.twoboxvideoslider').removeClass("active");
            $(videos[i]).parents('.boxVideo').removeClass("active");
            $(videos[i]).parent().find('.boxVideo__btn').removeClass("active");
        }
    }
}, true);

//smoothscroll
$(".smoothScroll").on('click', function(event) {
    if (this.hash !== "") {
    event.preventDefault();
     // Store hash
     var hash = this.hash;
      $('html, body').animate({ scrollTop: $(hash).offset().top}, 800, function(){ window.location.hash = hash;});
      } // End if
 });

 $(document).on("click",".popup_freebie_close",function () {
              $(this).parents("#popup_freebie").css('display','none').html('');
       $("html").removeClass("no-scroll")
});
  
//video-mute
 var video = document.getElementById("myVideo");
   
   if ($("#myVideo").prop("muted", !0)) {
   
       $("#muteSound img").click((function () {
           $(this).removeClass("active"),
               $(this).next("img").addClass("active")
       })),
           $("#muteSound .mute").click((function () {
               video.volume = .2,
                   $("#myVideo").prop("muted", !1)
           })),
           $(".vol1").click((function () {
               video.volume = .5,
                   $("#myVideo").prop("muted", !1)
           })),
           $(".vol2").click((function () {
               video.volume = 1,
                   $("#myVideo").prop("muted", !1)
           })),
           $(".vol3").click((function () {
               $(".mute").addClass("active"),
                   $("#myVideo").prop("muted", !0)
           }))
   
   }

/** joinknowledgefrom* */
$("form#joinknowledgefrom").submit(function(){
  //console.log('joinuss');
       email = $("#jksubscribeemail");
         if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.val())) {email.addClass("needsfilled");email.val('Enter valid email address');}
       if ($(":input").hasClass("needsfilled")) { 
           return false;
       }else {
         var useremail =$("#jksubscribeemail").val();
         $.ajax({
           url: "https://mytrulydeals.com/trulybeauty/subscribe.php",
           type: 'POST',
           data: {ajaxaction:"subscribelist",subemailaddress:useremail},
           async: true,
           success: function (response) { 
             $("form#joinknowledgefrom").get(0).reset()
               alert('Thanks for joining our Join Knowledge.');
               },
           timeout: 5000000, // sets timeout to 5 seconds
           }); 
       
         return false;
       }
});
// $(document).ready(function () {
//                 const slides = document.querySelectorAll('.announcement_slider_s .header_announcement');
//                 let currentIndex = 0;

//                 slides.forEach(slide => {
//                     slide.style.opacity = 0;
//                     slide.style.visibility = 'hidden'; // Initially hide all slides
//                     slide.style.transition = 'opacity 1s, visibility 1s';
//                 });

//                 slides[currentIndex].style.opacity = 1;
//                 slides[currentIndex].style.visibility = 'visible'; // Show the first slide

//                 function showSlide() {
//                     slides[currentIndex].style.opacity = 0;
//                     slides[currentIndex].style.visibility = 'hidden';

//                     currentIndex = (currentIndex + 1) % slides.length;

//                     setTimeout(() => {
//                         slides[currentIndex].style.opacity = 1;
//                         slides[currentIndex].style.visibility = 'visible';
//                     }, 200);
//                 }

//                 setInterval(showSlide, 5000);

//             });

            $(".close_announcement,.close_announcement-i").click(function () {
                $(".header_announcements_s").hide();
              $(".header_announcementstime").hide();
            });
